import classNames from 'classnames';
import { ReactNode } from 'react';

interface SelectButtonOption<T> {
  label: ReactNode;
  value: T;
}

interface SelectButtonsProps<T> {
  options: SelectButtonOption<T>[];
  value?: T;
  onChange: (value: T) => void;
  label?: string;
  classes?: {
    container?: string;
    button?: string;
    buttonsContainer?: string;
  };
  disabled?: boolean;
  capitalize?: boolean;
}

export const SelectButtonsNew = <T,>({
  options,
  value,
  onChange,
  classes,
  label,
  disabled = false,
  capitalize = true,
}: SelectButtonsProps<T>) => {
  return (
    <div
      className={classNames({ 'w-full': !classes?.container?.includes('w-') }, classes?.container)}
    >
      {label && (
        <label
          className={classNames(
            'flex flex-row justify-between text-[10px] leading-[18px] mb-2',
            'font-[Inter] text-gray-900 text-opacity-[.64] uppercase font-medium',
          )}
        >
          {label}
        </label>
      )}

      <div
        className={classNames(
          'flex items-center bg-gray-100 rounded min-h-[36px] divide-x divide-gray-200',
          classes?.buttonsContainer,
        )}
      >
        {options.map((option, index) => (
          <div key={index} className="w-full flex items-center justify-center">
            <button
              type="button"
              onClick={e => {
                onChange(option.value);
                e.currentTarget.blur();
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') e.preventDefault();
              }}
              disabled={disabled}
              className={classNames(
                'mx-[2px] w-full min-h-[32px] rounded-sm select-none',
                'font-[Inter] text-sm leading-[20px] transition-all duration-300',
                {
                  'bg-white border-[1px] border-blue-700': option.value === value,
                  'text-gray-600 hover:text-gray-900': option.value !== value,
                  capitalize: capitalize,
                },
                classes?.button,
              )}
            >
              {option.label}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
